import Component from "@base/Component.js";
import t from "@/services/translationService.js";
import { lockScroll, unlockScroll } from "@/services/scrollLock.js";

const CONSENT_KEY = "cookie-consent";

/**
 * Cookie consent banner. Mount to document.body; only shown when no choice has
 * been stored yet. The site uses no tracking cookies, so this is informational.
 */
export default class CookieBanner extends Component {
  static shouldShow() {
    return !localStorage.getItem(CONSENT_KEY);
  }

  render() {
    return `
      <div class="cookie-banner">
        <div class="cookie-card">
          <h2>${t.t("cookie.title")}</h2>
          <p>${t.t("cookie.text")}</p>
          <ul>
            <li>${t.t("cookie.language")}</li>
            <li>${t.t("cookie.banner")}</li>
            <li>${t.t("cookie.auth")}</li>
          </ul>
          <div class="cookie-actions">
            <button class="btn-primary" data-choice="accept">${t.t("cookie.accept")}</button>
            <button class="btn-secondary" data-choice="reject">${t.t("cookie.reject")}</button>
          </div>
        </div>
      </div>`;
  }

  onMounted() {
    lockScroll();
    this.$$("[data-choice]").forEach((btn) => {
      this.listen(btn, "click", () => {
        localStorage.setItem(CONSENT_KEY, btn.getAttribute("data-choice"));
        this.unmount();
      });
    });
  }

  onBeforeUnmount() {
    unlockScroll();
  }
}
